<template>
  <div class="box">
    <ShowGrMem v-if="showInfo&&inqType=='gr'" :showInfo="showInfo"></ShowGrMem>
    <ShowQyMem v-if="showInfo&&inqType=='dw'" :showInfo="showInfo"></ShowQyMem>
    <ShowBanMem v-if="showInfo&&inqType=='ban'" :showInfo="showInfo"></ShowBanMem>
    <!-- <ShowGrMemM v-if="$IsPhone&&showInfo&&inqType=='gr'" :showInfo="showInfo"></ShowGrMemM> -->
    <!-- <ShowQyMemM v-if="$IsPhone&&showInfo&&inqType=='dw'" :showInfo="showInfo"></ShowQyMemM>
    <ShowBanMemM v-if="$IsPhone&&showInfo&&inqType=='ban'" :showInfo="showInfo"></ShowBanMemM> -->
  </div>
</template>
<script>
import ShowGrMem from './show/ShowGrMem.vue';
import ShowQyMem from './show/ShowQyMem.vue';
import ShowQyMemM from './show/ShowQyMemM.vue';
import ShowGrMemM from './show/ShowGrMemM.vue';
import ShowBanMem from './show/ShowBanMem.vue';
import ShowBanMemM from './show/ShowBanMemM.vue';
const rate = window.outerWidth / 599;
import { getCompanyMember ,getPersonalMember,getBeiAn } from '@/request/index';

export default {
  metaInfo: {
    title: '查询结果',
    meta: [
      {
        name: 'viewport', content:
          `width=device-width, user-scalable=yes, initial-scale=${rate}, maximum-scale=${10}, minimum-scale=${rate}`
      }
    ]
  },
  name: "show",
  components: {
    ShowGrMem,//人员证书
    ShowQyMem,
    ShowGrMemM,//人员证书
    ShowQyMemM,
    ShowBanMemM,
    ShowBanMem
  },
  data() {
    return {
      showInfo: null,
      inqType:'gr',
      selectid:""
    }
  },
  created() {
    this.query();
  },
  mounted() {
    var lastTouchEnd = 0;
    document.addEventListener(
      "touchend",
      function (event) {
        var now = new Date().getTime();
        if (now - lastTouchEnd <= 300) {
          event.preventDefault();
        }
        lastTouchEnd = now;
      },
      false
    );
  },
  methods: {
    /**
     *  cname: "单位名称"或姓名,
        ccode: "信用代码"或证件号,
        bzcode: "证书编号"或标准号
     */
    async query() {
      let { name, code,inqType,companyname } = this.$route.query;
      this.inqType = inqType;
      if(inqType =='gr')
      {
        let result = await getPersonalMember(name,code);
        if (result.success) {
          this.showInfo = result.data[0];
        } else {
          this.showInfo = null; 
          this.$router.push('/InqMember?inqtype=gr');
        }
      }else if(inqType =='dw'){
        let result = await getCompanyMember(companyname,code);
        if (result.success) {
          this.showInfo = result.data[0];
        } else {
          this.showInfo = null; 
          this.$router.push('/InqMember?inqtype=dw');
        }
      }else{
        let result = await getBeiAn(companyname,code);
        if (result.success) {
          this.showInfo = result.data[0];
        } else {
          this.showInfo = null; 
          this.$router.push('/InqMember?inqtype=ban');
        }
      }
      
    },
    /**
     * nianjian转Array
     * "第一年,第二年,第三年"
     * @param {showInfo} obj 
     * @return showInfo
     */
    dealNianjian(obj) {
      return obj;
    },
    /**
     * 技术支持单位
     * 名称##网址||名称##网址
     * @param {showInfo} obj 
     * @return showInfo
     */
    dealJszcdw(obj) {
      return obj;
    }
  }
};
</script>
<style scoped>
.box {
  position: relative;
  width: 100%;
  height: 100%;
}
</style>